export default function CTASection() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden">
          {/* Background Image */}
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20background%20with%20soft%20organic%20shapes%2C%20gentle%20terracotta%20and%20cream%20gradient%2C%20elegant%20subtle%20texture%2C%20modern%20clean%20aesthetic%2C%20editorial%20style%2C%20high%20end%20design%2C%20soft%20ambient%20light%2C%20warm%20neutral%20tones&width=1200&height=600&seq=cta-section-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/80 to-background-50/95"></div>
          </div>

          <div className="relative z-10 p-8 md:p-12 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              Gotowy, aby zacząć?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto mb-6 leading-relaxed">
              Przejdź do <strong>Kakobuy Spreadsheet</strong> i odkryj setki starannie wyselekcjonowanych produktów w najlepszych cenach.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Kakobuy Spreadsheet
                <i className="ri-arrow-right-line text-base"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50 border border-background-300/60 text-foreground-800 text-sm md:text-base font-semibold hover:bg-background-100 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Buy It Now
                <i className="ri-shopping-bag-line text-base"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}